import React from 'react';
import { ClipLoader } from 'react-spinners';
import { useGeneralHooks } from '../../../../../../../Hooks/hooks';
import useProfileGallery from './gallery-hook';
import { ButtonTypes } from '../../../../../../../Interfaces/componentTypes';
import { IEditBusinessProfileMainProps } from '../ProfileMain/profileMainInfo';
import ImageUploader from './ImageUploader/imageUploader';
import Button from '../../../../../../../Components/Button/button';
import { RedClose } from '../../../../../../../Assets/Icons';
import styles from './gallery.module.scss';

const ProfileGallery: React.FC<IEditBusinessProfileMainProps> = (props) => {
    const { t, baseURL } = useGeneralHooks();
    const {
        gallery,
        isChanged,
        isLoading,
        imageLoading,
        removingImage,
        onRemoveImage,
        onUpdateGallery,
        handleFileInputChange,
    } = useProfileGallery(props);
    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <p>
                    {t('My_Business.Business_Profile.Gallery.Header')}
                </p>
            </div>
            <div className={styles.body}>
                {
                    gallery.length > 0
                    &&
                    gallery.map((image, index) => {
                        return (
                            <div key={index} className={styles.imageContainer}>
                                <img src={RedClose} alt={`redClose.svg`} className={styles.deleteIcon} onClick={() => onRemoveImage(image)} />
                                <img src={`${baseURL}${image}`} alt='image.png' className={styles.image} />
                                {
                                    removingImage === image
                                    &&
                                    <div className={styles.removeLoader}>
                                        <ClipLoader color="#aa002b" size={50} />
                                    </div>
                                }
                            </div>
                        )

                    })
                }
                {
                    gallery.length < 7
                        ?
                        <ImageUploader
                            id='gallery'
                            handleFileInputChange={handleFileInputChange}
                            loading={imageLoading}
                        />
                        :
                        <div className={styles.limitBox}>
                            <p>
                                {t('My_Business.Business_Profile.Gallery.Limit')}
                            </p>
                        </div>
                }
            </div>
            {
                gallery.length > 0 && isChanged
                &&
                <Button
                    buttonType={ButtonTypes.Primery}
                    onClick={onUpdateGallery}
                    title={t('Buttons.Save')}
                    buttonStyle={styles.button}
                    isLoading={isLoading}
                />
            }
        </div>
    )
}

export default ProfileGallery
